import React, { useContext, useEffect } from 'react'
import useDataClient from './useDataClient'
import { SarEnvFederalState } from '../types'
import { AppContext } from '../context'
import useUserStorage from './useUserStorage'
import { sarenvAdapter } from '../adapter/sarsetting.adapter'

export default function useCatFederalStates() {
    const appContext = useContext(AppContext)
    const localData = useUserStorage<SarEnvFederalState[]>('federalStates')
    const federalStatesClient = useDataClient<SarEnvFederalState[]>({ appContext })

    useEffect(() => {
        if (!localData.data) {
            federalStatesClient.executeRequest(sarenvAdapter.getFederalStates())
        }
    }, [])

    useEffect(() => {
        if (federalStatesClient.status.data) {
            localData.setData(federalStatesClient.status.data)
        }
    }, [federalStatesClient.status.data])

    return localData.data || federalStatesClient.status.data || []
}
